export default "<iframe id=\"iframe1\" *ngIf=\"src\" class=\"frameview\" [src]=\"src\" frameborder=\"0\" (load)=\"onLoad()\"></iframe>\r\n\r\n";